import { render } from "./MessagesView.vue?vue&type=template&id=8283298c&ts=true"
import script from "./MessagesView.vue?vue&type=script&lang=ts"
export * from "./MessagesView.vue?vue&type=script&lang=ts"

import "./MessagesView.vue?vue&type=style&index=0&id=8283298c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Messages/MessagesView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8283298c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8283298c', __exports__)) {
    api.reload('8283298c', __exports__)
  }
  
  module.hot.accept("./MessagesView.vue?vue&type=template&id=8283298c&ts=true", () => {
    api.rerender('8283298c', render)
  })

}


export default __exports__